import { Component, EventEmitter, HostListener, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-ticket',
  templateUrl: './select-ticket.component.html',
  styleUrls: ['./select-ticket.component.scss']
})
export class SelectTicketComponent implements OnInit {
  @Output() next = new EventEmitter<number[]>();

  selectedNumbers: number[] = [];
  isMobile = false;

  matrix: number[][] = Array.from({ length: 9 }, (_, i) =>
    Array.from({ length: 10 }, (_, j) => i * 10 + j + 1)
  );

  @HostListener('window:resize', [])
  onResize() {
    this.isMobile = window.innerWidth <= 1060;
  }

  ngOnInit(): void {
    this.onResize();
  }

  toggleNumberSelection(num: number): void {
    if (this.selectedNumbers.length < 5) {
      this.selectedNumbers.push(num);
    }
  }

  deselectNumber(num: number): void {
    this.selectedNumbers = this.selectedNumbers.filter(n => n !== num);
  }

  isSelected(num: number): boolean {
    return this.selectedNumbers.includes(num);
  }

  resetSelection(): void {
    this.selectedNumbers = [];
  }

  proceed(): void {
    if (this.selectedNumbers.length === 5) {
      this.next.emit(this.selectedNumbers);
    } else {
      console.error('Seleziona 5 numeri prima di procedere');
    }
  }

}
